import styled from '@emotion/styled';
import { Flex } from '@revenuemarket/cds';

export const LayoutWrapper = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 14px 8px;
  width: 100%;
`;
